import { Link } from "react-router-dom";

interface Props {
  id: string;
  industry: string;
  name: string;
  metric: string;
  metricLabel: string;
  year: string;
  slug?: string;
}

export default function ProjectRow({ id, industry, name, metric, metricLabel, year, slug }: Props) {
  return (
    <Link
      to={slug || "/work"}
      className="owl-proj-row"
      style={{
        display: "grid",
        gridTemplateColumns: "15% 55% 15% 15%",
        alignItems: "center",
        padding: "28px 0",
        borderBottom: "0.5px solid rgba(212,168,67,0.15)",
        cursor: "pointer",
        transition: "background 0.25s ease",
        textDecoration: "none",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "#0E0E0E";
        const nameElement = e.currentTarget.querySelector(".proj-name");
        if (nameElement instanceof HTMLElement) {
          nameElement.style.color = "#D4A843";
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        const nameElement = e.currentTarget.querySelector(".proj-name");
        if (nameElement instanceof HTMLElement) {
          nameElement.style.color = "#F8F4EC";
        }
      }}
    >
      <div>
        <div
          style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontWeight: 700,
            fontSize: 11,
            letterSpacing: "0.3em",
            color: "#D4A843",
            marginBottom: 4,
          }}
        >
          {id}
        </div>
        <span
          style={{
            background: "rgba(212,168,67,0.12)",
            border: "1px solid rgba(212,168,67,0.3)",
            color: "#D4A843",
            fontFamily: "'Barlow Condensed', sans-serif",
            fontWeight: 700,
            fontSize: 10,
            letterSpacing: "0.2em",
            padding: "3px 10px",
            borderRadius: 2,
          }}
        >
          {industry}
        </span>
      </div>
      <div
        className="proj-name"
        style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 300,
          fontSize: "clamp(18px, 2.5vw, 32px)",
          color: "#F8F4EC",
          transition: "color 0.25s ease",
          paddingRight: 24,
        }}
      >
        {name}
      </div>
      <div>
        <div
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: "clamp(20px, 2.5vw, 32px)",
            color: "#D4A843",
          }}
        >
          {metric}
        </div>
        <div
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 300,
            fontSize: 12,
            color: "#908A83",
            marginTop: 2,
          }}
        >
          {metricLabel}
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
        <span
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 300,
            fontSize: 13,
            color: "#908A83",
          }}
        >
          {year}
        </span>
        <span
          style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: "0.15em",
            color: "#D4A843",
          }}
        >
          VIEW →
        </span>
      </div>
    </Link>
  );
}

